<div class="heka-m3-dialog-container-basic">
  <div class="dialog-header">
    <h4>{{'MULTI_DOMAIN.START.INVITATIONS.ERROR.TITLE'|translate}}</h4>
  </div>
  <mat-dialog-content class="dialog-content">
    <div>
      {{'MULTI_DOMAIN.START.INVITATIONS.ERROR.DESCRIPTION'|translate}}
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button mat-flat-button color="primary"
      mat-dialog-close>{{'GENERAL.OK'|translate}}</button>
  </mat-dialog-actions>
</div>
